import { render, staticRenderFns } from "./TextInPills.vue?vue&type=template&id=0a928f76&scoped=true&"
import script from "./TextInPills.vue?vue&type=script&lang=js&"
export * from "./TextInPills.vue?vue&type=script&lang=js&"
import style0 from "./TextInPills.vue?vue&type=style&index=0&id=0a928f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a928f76",
  null
  
)

export default component.exports